import {
    ADD_ACTIVATION_EXTRA_PARAM,
    ADD_PREFERENCES,
    DELETE_ACTIVATION_EXTRA_PARAM,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    ProviderActionTypes,
    RESET_FILTERS,
    RESET_PROVIDER,
    SET_ACTIVATION_LIST,
    SET_EDIT_STEP,
    SET_ERRORS, SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PICTURE_ERRORS,
    SET_POST_FINISHED,
    SET_PREFERENCES as SET_PROVIDER_PREFERENCES,
    SET_PROVIDER,
    SET_PROVIDER_ACTIVATION,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_AUTO_BOOKING,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_EDIT,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_ACTIVATION_CONTENT_TYPES,
    UPDATE_ACTIVATION_EMAIL,
    UPDATE_ACTIVATION_ENDPOINT,
    UPDATE_ACTIVATION_EXTRA_PARAM_KEY,
    UPDATE_ACTIVATION_EXTRA_PARAM_VALUE,
    UPDATE_ACTIVATION_IDENTIFIER,
    UPDATE_ACTIVATION_KEY,
    UPDATE_ACTIVATION_ORGANISATION,
    UPDATE_ADDRESS,
    UPDATE_BOOKING_EMAIL,
    UPDATE_CITY,
    UPDATE_CODE,
    UPDATE_COMPLEMENTARY_ADDRESS,
    UPDATE_CONTACT_EMAIL,
    UPDATE_CONTENT_TYPE,
    UPDATE_COUNTRY,
    UPDATE_FILTER_CONTENT_TYPE,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_NAME,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_LANGUAGE,
    UPDATE_NAME,
    UPDATE_PAYMENT_TYPE,
    UPDATE_PHONE_NUMBER,
    UPDATE_PICTURE,
    UPDATE_PICTURE_PROGRESS,
    UPDATE_SECONDARY_PHONE_NUMBER,
    UPDATE_ZIP_CODE,
    SET_COLUMNS
} from './actionTypes';
// Types
import { Column } from '../objects/column';
import { ProviderState } from '../objects/providerState';
import { Preferences } from '../../profile/objects/preferences';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { ProviderActivation } from '../objects/providerActivation';

const initialState: ProviderState = {
    activation_content_type: [],
    activation_create: false,
    activation_edit: null,
    activation_email: '',
    activation_email_error: '',
    activation_endpoint: '',
    activation_endpoint_error: '',
    activation_extra_params: [],
    activation_identifier: '',
    activation_identifier_error: '',
    activation_key: '',
    activation_key_error: '',
    activation_list: [],
    activation_organisation: null,
    address: '',
    address_error: '',
    auto_booking: false,
    booking_email: '',
    booking_email_error: '',
    city: '',
    city_error: '',
    code: '',
    code_error: '',
    columns: [{
        label: 'provider-name',
        field_name: 'PROVIDER_NAME',
        checked: true,
        order_by: 'provider__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'content-types',
        field_name: 'CONTENT_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }],
    complementary_address: '',
    complementary_address_error: '',
    contact_email: '',
    contact_email_error: '',
    content_type: [],
    content_type_error: '',
    count: 0,
    country: '',
    country_error: '',
    create: false,
    custom_provider: null,
    edit: false,
    edit_step: 'INFO',
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_content_type: [],
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_name: '',
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    language: null,
    limit: 50,
    list: null,
    name: '',
    name_error: '',
    order: 'asc',
    order_by: 'name',
    page: 0,
    payment_type: ['VOUCHER'],
    payment_type_error: '',
    phone_number: '',
    phone_number_error: '',
    picture: null,
    picture_errors: null,
    picture_progress: 0,
    preferences: [],
    provider: null,
    refresh: false,
    running: false,
    search: '',
    secondary_phone_number: '',
    secondary_phone_number_error: '',
    zip_code: '',
    zip_code_error: ''
};

const providerActivation: ProviderActivation = {
    configuration: {
        email: '',
        endpoint: '',
        extra_params: [],
        identifier: '',
        key: ''
    },
    enabled_content_types: [],
    owner: null
};

export default (state: ProviderState = initialState, action: ProviderActionTypes | ProfileActionTypes): ProviderState => {
    switch (action.type) {
        case ADD_ACTIVATION_EXTRA_PARAM: {
            let extra_params = [...state.activation_extra_params];
            extra_params.push({key: '', value: ''});
            return {...state, activation_extra_params: extra_params};
        }
        case ADD_PREFERENCES: {
            return {...state, preferences: [...state.preferences, ...action.payload]};
        }
        case DELETE_ACTIVATION_EXTRA_PARAM: {
            let extra_params = [...state.activation_extra_params];
            extra_params.splice(action.payload, 1);
            return {...state, activation_extra_params: extra_params};
        }
        case MOVE_DOWN_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload + 1]};
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case MOVE_UP_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload - 1]};
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_content_type: [],
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_name: '',
                filter_period: 'CREATION',
                filter_period_type: 0
            }
        }
        case RESET_PROVIDER: {
            return {
                ...state,
                address: '',
                address_error: '',
                auto_booking: false,
                booking_email: '',
                booking_email_error: '',
                city: '',
                city_error: '',
                code: '',
                code_error: '',
                complementary_address: '',
                complementary_address_error: '',
                contact_email: '',
                contact_email_error: '',
                content_type: [],
                content_type_error: '',
                country: '',
                country_error: '',
                create: false,
                custom_provider: null,
                edit_step: 'INFO',
                language: null,
                name: '',
                name_error: '',
                payment_type: ['VOUCHER'],
                payment_type_error: '',
                phone_number: '',
                phone_number_error: '',
                picture: null,
                picture_errors: null,
                secondary_phone_number: '',
                secondary_phone_number_error: '',
                zip_code: '',
                zip_code_error: ''
            };
        }
        case SET_ACTIVATION_LIST: {
            return {...state, activation_list: action.payload};
        }
        case SET_EDIT_STEP: {
            return {...state, edit_step: action.payload};
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: ProviderState = {...state};
            errors.map(error => {
                new_state[error.key] = error.error;
            });
            return {...new_state};
        }
        case SET_EXPORT_TYPE: {
            return {...state, export_type: action.payload};
        }
        case SET_LIMIT: {
            return {...state, list: null, limit: action.payload};
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return {...state, count: count, list: results, running: false};
        }
        case SET_ORDER_BY: {
            return {...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return {...state, list: null, page: action.payload};
        }
        case SET_PICTURE_ERRORS: {
            return {...state, picture_progress: 0, picture_errors: action.payload};
        }
        case SET_POST_FINISHED: {
            return {
                ...state,
                address: '',
                address_error: '',
                auto_booking: false,
                booking_email: '',
                booking_email_error: '',
                city: '',
                city_error: '',
                code: '',
                code_error: '',
                complementary_address: '',
                complementary_address_error: '',
                contact_email: '',
                contact_email_error: '',
                content_type: [],
                content_type_error: '',
                country: '',
                country_error: '',
                create: false,
                custom_provider: null,
                edit_step: 'INFO',
                language: null,
                name: '',
                name_error: '',
                payment_type: ['VOUCHER'],
                payment_type_error: '',
                phone_number: '',
                phone_number_error: '',
                picture: null,
                picture_errors: null,
                refresh: !state.refresh,
                secondary_phone_number: '',
                secondary_phone_number_error: '',
                zip_code: '',
                zip_code_error: ''
            };
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            let new_columns: Column[] = [];
            let new_order_by = '-created_date';
            let new_order: 'asc' | 'desc' = 'asc';
            let field_name: string[] = [];
            let provider_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'PROVIDER') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                            case 'PROVIDER_NAME':
                                new_columns.push({label: 'provider-name', field_name: preference.field_name, checked: preference.active, order_by: 'provider__name', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'provider__name' : new_order_by;
                                break;
                            case 'CONTENT_TYPE':
                                new_columns.push({label: 'content-types', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'CREATED_DATE':
                                new_columns.push({label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'created_date' : new_order_by;
                                break;
                            case 'CREATED_BY':
                                new_columns.push({label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'creator__username' : new_order_by;
                                break;
                            case 'MODIFIED_DATE':
                                new_columns.push({label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'modified_date' : new_order_by;
                                break;
                            case 'MODIFIED_BY':
                                new_columns.push({label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'last_author__username' : new_order_by;
                                break;
                            default:
                                break;
                        }
                        provider_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({...column});
                    }
                });
            }
            return {...state, preferences: provider_preferences, columns: new_columns, order_by: new_order_by, order: new_order};
        }
        case SET_PROVIDER: {
            return {
                ...state,
                address: action.payload.street !== null ? action.payload.street : '',
                auto_booking: action.payload.auto_reservation_email,
                booking_email: action.payload.reservation_email !== null ? action.payload.reservation_email : '',
                city: action.payload.city !== null ? action.payload.city : '',
                code: action.payload.provider.code !== null ? action.payload.provider.code : '',
                complementary_address: action.payload.street2 !== null ? action.payload.street2 : '',
                contact_email: action.payload.email !== null ? action.payload.email : '',
                content_type: action.payload.available_content_types,
                country: action.payload.country !== null ? action.payload.country : '',
                custom_provider: action.payload,
                language: action.payload.locale_code,
                name: action.payload.provider.name,
                payment_type: action.payload.accepted_payment_form,
                phone_number: action.payload.phone_number !== null ? action.payload.phone_number : '',
                picture: action.payload.provider.logo,
                secondary_phone_number: action.payload.phone_number_2 !== null ? action.payload.phone_number_2 : '',
                zip_code: action.payload.zip_code !== null ? action.payload.zip_code : ''
            };
        }
        case SET_PROVIDER_ACTIVATION: {
            if (action.payload === true) {
                return {...state, activation_edit: null, activation_create: true};
            } else if (action.payload === false) {
                return {
                    ...state,
                    activation_content_type: [],
                    activation_email: '',
                    activation_email_error: '',
                    activation_endpoint: '',
                    activation_endpoint_error: '',
                    activation_extra_params: [],
                    activation_identifier: '',
                    activation_identifier_error: '',
                    activation_key: '',
                    activation_key_error: '',
                    activation_organisation: null,
                    activation_edit: null,
                    activation_create: false
                };
            } else if (action.payload === null) {
                return {...state};
            } else if (state.activation_create) {
                let activation_list = [...state.activation_list];
                activation_list.push(action.payload);
                return {
                    ...state,
                    activation_content_type: [],
                    activation_email: '',
                    activation_email_error: '',
                    activation_endpoint: '',
                    activation_endpoint_error: '',
                    activation_extra_params: [],
                    activation_identifier: '',
                    activation_identifier_error: '',
                    activation_key: '',
                    activation_key_error: '',
                    activation_organisation: null,
                    activation_create: false,
                    activation_list: activation_list
                };
            } else if (state.activation_edit !== null) {
                let activation_list = [...state.activation_list];
                for (let i = 0; i < activation_list.length; i++) {
                    if (activation_list[i].id === action.payload.id) {
                        activation_list[i] = action.payload;
                        break;
                    }
                }
                return {
                    ...state,
                    activation_content_type: [],
                    activation_email: '',
                    activation_email_error: '',
                    activation_endpoint: '',
                    activation_endpoint_error: '',
                    activation_extra_params: [],
                    activation_identifier: '',
                    activation_identifier_error: '',
                    activation_key: '',
                    activation_key_error: '',
                    activation_organisation: null,
                    activation_edit: null,
                    activation_list: activation_list
                };
            } else {
                return {
                    ...state,
                    activation_content_type: action.payload.enabled_content_types,
                    activation_email: action.payload.configuration.email !== null ? action.payload.configuration.email : '',
                    activation_email_error: '',
                    activation_endpoint: action.payload.configuration.endpoint !== null ? action.payload.configuration.endpoint : '',
                    activation_endpoint_error: '',
                    activation_extra_params: action.payload.configuration.extra_params,
                    activation_identifier: action.payload.configuration.identifier !== null ? action.payload.configuration.identifier : '',
                    activation_identifier_error: '',
                    activation_key: action.payload.configuration.key !== null ? action.payload.configuration.key : '',
                    activation_key_error: '',
                    activation_organisation: action.payload.owner,
                    activation_edit: {...action.payload}
                };
            }
        }
        case SET_PROVIDER_PREFERENCES: {
            return {...state, preferences: action.payload};
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            return {...state, list: null, search: action.payload, page: 0};
        }
        case TOGGLE_AUTO_BOOKING: {
            return {...state, auto_booking: !state.auto_booking};
        }
        case TOGGLE_COLUMN: {
            let columns = [...state.columns];
            let column = {...columns[action.payload]};
            column.checked = !column.checked;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case TOGGLE_CREATE: {
            return {...state, create: !state.create};
        }
        case TOGGLE_EDIT: {
            return {...state, edit: !state.edit};
        }
        case TOGGLE_EXPORT: {
            return {...state, export_list: action.payload};
        }
        case TOGGLE_EXPORT_FULL: {
            return {...state, export_full: !state.export_full};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        case UPDATE_ACTIVATION_CONTENT_TYPES: {
            return {...state, activation_content_type: action.payload};
        }
        case UPDATE_ACTIVATION_EMAIL: {
            return {...state, activation_email: action.payload};
        }
        case UPDATE_ACTIVATION_ENDPOINT: {
            return {...state, activation_endpoint: action.payload};
        }
        case UPDATE_ACTIVATION_EXTRA_PARAM_KEY: {
            const { value, index } = action.payload;
            let extra_params = [...state.activation_extra_params];
            let extra_param = {...extra_params[index]};
            extra_param.key = value;
            extra_params[index] = extra_param;
            return {...state, activation_extra_params: extra_params};
        }
        case UPDATE_ACTIVATION_EXTRA_PARAM_VALUE: {
            const { value, index } = action.payload;
            let extra_params = [...state.activation_extra_params];
            let extra_param = {...extra_params[index]};
            extra_param.value = value;
            extra_params[index] = extra_param;
            return {...state, activation_extra_params: extra_params};
        }
        case UPDATE_ACTIVATION_IDENTIFIER: {
            return {...state, activation_identifier: action.payload};
        }
        case UPDATE_ACTIVATION_KEY: {
            return {...state, activation_key: action.payload};
        }
        case UPDATE_ACTIVATION_ORGANISATION: {
            return {...state, activation_organisation: action.payload};
        }
        case UPDATE_ADDRESS: {
            return {...state, address: action.payload};
        }
        case UPDATE_BOOKING_EMAIL: {
            return {...state, booking_email: action.payload};
        }
        case UPDATE_CITY: {
            return {...state, city: action.payload};
        }
        case UPDATE_CODE: {
            return {...state, code: action.payload};
        }
        case UPDATE_COMPLEMENTARY_ADDRESS: {
            return {...state, complementary_address: action.payload};
        }
        case UPDATE_CONTACT_EMAIL: {
            return {...state, contact_email: action.payload};
        }
        case UPDATE_CONTENT_TYPE: {
            return {...state, content_type: action.payload};
        }
        case UPDATE_COUNTRY: {
            return {...state, country: action.payload};
        }
        case UPDATE_FILTER_CONTENT_TYPE: {
            return {...state, filter_content_type: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return {...state, filter_created_date_gte: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return {...state, filter_created_date_lte: action.payload};
        }
        case UPDATE_FILTER_CREATOR: {
            return {...state, filter_creator: action.payload};
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return {...state, filter_last_author: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return {...state, filter_modified_date_gte: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return {...state, filter_modified_date_lte: action.payload};
        }
        case UPDATE_FILTER_NAME: {
            return {...state, filter_name: action.payload};
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return {...state, filter_period_type: action.payload};
        }
        case UPDATE_LANGUAGE: {
            return {...state, language: action.payload === 'null' ? null : action.payload};
        }
        case UPDATE_NAME: {
            return {...state, name: action.payload};
        }
        case UPDATE_PAYMENT_TYPE: {
            return {...state, payment_type: action.payload};
        }
        case UPDATE_PHONE_NUMBER: {
            return {...state, phone_number: action.payload};
        }
        case UPDATE_PICTURE: {
            return {...state, picture_progress: 0, picture: action.payload};
        }
        case UPDATE_PICTURE_PROGRESS: {
            return {...state, picture_progress: action.payload};
        }
        case UPDATE_SECONDARY_PHONE_NUMBER: {
            return {...state, secondary_phone_number: action.payload};
        }
        case UPDATE_ZIP_CODE: {
            return {...state, zip_code: action.payload};
        }
        case SET_COLUMNS: {
            return {...state, columns: action.payload};
        }
        default:
            return state;
    }
};